import { jsxs, jsx } from "@emotion/react/jsx-runtime";
import { CardWrapper } from "./auth-service-tools94.js";
import { CardHeader } from "./auth-service-tools95.js";
import { CardBody } from "./auth-service-tools96.js";

const Card = (_ref) => {
  let {
    headerContent,
    children,
    title,
    bodyStyles,
    ...rest
  } = _ref;
  return /* @__PURE__ */jsxs(CardWrapper, { ...rest,
    children: [(title || headerContent) && /* @__PURE__ */jsx(CardHeader, {
      title,
      ...rest,
      children: headerContent
    }), /* @__PURE__ */jsx(CardBody, {
      css: bodyStyles,
      children
    })]
  });
};

export { Card };